import { MARGINS_BLOCKS } from '@features/cms/const';
import { TMarginsTypes } from '@features/cms/typescript';
import theme from '@styles/theme';
export default {
  sectionContainer: (marginTop: TMarginsTypes, marginBottom: TMarginsTypes) => ({
    bg: theme.rawColors.neutralWhite,
    mt: MARGINS_BLOCKS[marginTop],
    mb: MARGINS_BLOCKS[marginBottom],
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  }),
  container: (background: string, count: number) => ({
    background: background || theme.rawColors.uspGrey,
    padding: count > 2 ? ['48px 0', '48px 0', '64px 24px', '64px 24px', '80px 10.15625vw'] : ['48px 0px', '48px 0px', '64px 0', '64px 0', '80px 0'],
    display: 'flex',
    flexDirection: 'column',
    rowGap: 24
  })
};